import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CommonWebService, HttpResponse, ProjectDetail, UserHttpService, AddProject, SearchProjectForm, ProjectListDetail, ActionStatus, ProjectsListReport, GenerateProjectReport, ProjectType } from "../public-api";
import { observableToBeFn } from "rxjs/internal/testing/TestScheduler";
@Injectable({
  providedIn: "root",
})
export class ProjectService {

  constructor(
    private http: HttpClient,
    private userSessionService: UserHttpService,
    private commonService: CommonWebService
  ) { }


  //group list
  getProjectList(limit?: number, offset?: number, searchParams?: SearchProjectForm): Observable<HttpResponse<ProjectListDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    if (searchParams && searchParams.keyword_search) {
      formData.append("keyword_search", searchParams.keyword_search ? searchParams.keyword_search : "");
    }
    if (searchParams && searchParams.clientId) {
      formData.append("client_id", searchParams.clientId ? searchParams.clientId : "");
    }
    if (searchParams && searchParams.project_id) {
      formData.append("project_id", searchParams.project_id ? searchParams.project_id : "");
    }
    if (searchParams && searchParams.fromDate) {
      formData.append("fromDate", searchParams.fromDate ? searchParams.fromDate : "");
    }
    if (searchParams && searchParams.toDate) {
      formData.append("toDate", searchParams.toDate ? searchParams.toDate : "");
    }
    if (searchParams && searchParams.status) {
      formData.append("status", searchParams.status ? searchParams.status : "");
    }
    if (limit !== undefined) {
      formData.append('limit', limit.toString());
    }
    if (offset !== undefined) {
      formData.append('offset', offset.toString());
    }
    return this.http.post<HttpResponse<ProjectListDetail[]>>("projects/projectList", formData);
  }

  getProjectTypes(): Observable<HttpResponse<ProjectType[]>> {
    const formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<ProjectType[]>>("projects/projectType", formData);
  }

  //add project
  addProject(body: AddProject, isEdit: boolean = false): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("project_name", body?.project_name ? body.project_name : "");
    formData.append("contact_id", body?.contact_id ? body.contact_id : "");
    formData.append("project_shortname", body?.project_shortname ? body.project_shortname : "");
    formData.append("client_id", body?.client_id ? body.client_id : "");
    formData.append("sub_client_id", body?.sub_client_id ? body.sub_client_id : "");
    formData.append("po_number", body?.po_number ? body.po_number : "");
    formData.append("project_contact", body?.project_contact ? body.project_contact : "");
    formData.append("project_total_amount", body?.project_total_amount ? body.project_total_amount : "");
    formData.append("project_quotation", body?.project_quotation ? body.project_quotation : "");
    formData.append("project_start_date", body?.project_start_date ? this.commonService.changeDateFormat(body.project_start_date as Date) : "");
    formData.append("project_end_date", body?.project_end_date ? this.commonService.changeDateFormat(body.project_end_date as Date) : "");
    formData.append("project_manager_id", body?.project_manager_id ? body.project_manager_id : "");
    formData.append("project_description", body?.project_description ? body.project_description : "");
    formData.append("budget_hours", body?.budget_hours ? body.budget_hours : "");
    formData.append("project_type", body?.project_type ? body.project_type : "");

    if (body?.project_activity && body.project_activity.length > 0) {
      for (let i = 0; i < body.project_activity.length; i++) {
        formData.append(`project_activity[${i}][type]`, body.project_activity[i].type);
        formData.append(`project_activity[${i}][resource_id]`, body.project_activity[i].resource_id);
        formData.append(`project_activity[${i}][hours]`, body.project_activity[i].hours);
        formData.append(`project_activity[${i}][amount]`, body.project_activity[i].amount);
      };
    };

    if (isEdit && body.project_id) {
      formData.append('project_id', body.project_id ? body.project_id : "")
    };

    if (isEdit && body.project_status) {
      formData.append('project_status', body.project_status ? body.project_status : ActionStatus.PENDING);
    }

    const url = isEdit ? 'projects/updateProject' : 'projects/createProject';
    return this.http.post<HttpResponse<any>>(url, formData);
  }


  // generateQuotation(totalAmount: string): Observable<HttpResponse<{ pdf_link: string }>> {
  //   let formData = new FormData();
  //   formData.append("user_id", this.userSessionService.getUserInfo.user_id);
  //   formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
  //   formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
  //   formData.append("token", this.userSessionService.userToken);
  //   formData.append("quotation_amount", totalAmount ? totalAmount : "");
  //   return this.http.post<HttpResponse<{ pdf_link: string }>>("projects/generateQuotes", formData);
  // }

  generateQuotation(activities: { resource_id: string; hours: number; activity_name: string }[]): Observable<HttpResponse<{ pdf_link: string }>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    for (let i = 0; i < activities.length; i++) {
      formData.append(`project_activity[${i}][resource_id]`, activities[i].resource_id ? activities[i].resource_id.toString() : "");
      formData.append(`project_activity[${i}][hours]`, activities[i].hours ? activities[i].hours.toString() : "");
      formData.append(`project_activity[${i}][activity_name]`, activities[i].activity_name ? activities[i].activity_name : "");
    }
    return this.http.post<HttpResponse<{ pdf_link: string }>>("projects/generateQuotes", formData);
  }

  getProjectDetail(id: string): Observable<HttpResponse<ProjectDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("project_id", id ? id : "");
    return this.http.post<HttpResponse<ProjectDetail[]>>("projects/projectDetail", formData);
  }

  deleteProject(id: string): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("project_id", id ? id : "");
    return this.http.post<HttpResponse<any>>("projects/projectDelete", formData);
  }

  /*--Brand Managers List--*/
  getBrandManagersData(client_id: string, subclient_id: string): Observable<HttpResponse<string[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("client_id", client_id);
    formData.append("subclient_id", subclient_id);
    return this.http.post<HttpResponse<string[]>>("client/ClientContactList", formData);
  }
  /*--Get Brand Manager Name and email--*/
  getBrandManagerInfo(contact_id: string): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("contact_id", contact_id);
    return this.http.post<HttpResponse<any[]>>("client/ContactDetail", formData);
  }

  /*--Add activity--*/
  addProjectActivity(body: any, isEdit: boolean = false): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("activityName", body?.activityName);
    if (isEdit && body.activityId) {
      formData.append('activityId', body?.activityId)
    }
    return this.http.post<HttpResponse<any>>("projects/projectActivity", formData);
  }

  /*--get Project Activity Detail--*/
  getProjectActivityDetail(id: string): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("activityId", id);
    return this.http.post<HttpResponse<any>>("projects/projectActivity/detail", formData);
  }
  /*--Delete Project Activity--*/
  deleteProjectActivity(id: string): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("activityId", id);
    return this.http.post<HttpResponse<any>>("projects/projectActivity/delete", formData);
  }

  /*-- Project Report List--*/
  getProjectReportList(limit?: number, offset?: number, keyword_search?: string): Observable<HttpResponse<ProjectsListReport[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    if (limit !== undefined) {
      formData.append('limit', limit.toString());
    }
    if (offset !== undefined) {
      formData.append('offset', offset.toString());
    }
    if (keyword_search !== undefined && keyword_search.trim() !== "") {
      formData.append('keyword_search', keyword_search.trim());
    }
    return this.http.post<HttpResponse<any>>("projects/projectReport", formData);
  }

  /*--Project Reports--*/
  getProjectReportDetail(project_id: string, data?: GenerateProjectReport): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append('project_id', project_id);
    if (data?.activityId) {
      formData.append('activityId', data.activityId);
    }
    if (data?.reportfromDate) {
      formData.append('reportfromDate', data?.reportfromDate);
    }
    if (data?.reporttoDate) {
      formData.append('reporttoDate', data?.reporttoDate);
    }
    return this.http.post<HttpResponse<any>>("projects/projectReportDetail", formData);
  }

  /*--Project Reports--*/
  downloadProjectReport(project_id: string, data?: GenerateProjectReport): Observable<HttpResponse<any[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append('project_id', project_id);
    if (data?.activityId) {
      formData.append('activityId', data.activityId);
    }
    if (data?.reportfromDate) {
      formData.append('reportfromDate', data?.reportfromDate);
    }
    if (data?.reporttoDate) {
      formData.append('reporttoDate', data?.reporttoDate);
    }
    return this.http.post<HttpResponse<any>>("projects/projectReportDownload", formData);
  }

  /*--Download MIS Report (Excel)--*/
  downloadMISReport(project_id: string): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("project_id", project_id ? project_id : "");
    return this.http.post<HttpResponse<any>>("reports/projectMISReport/downloadExcel", formData);
  }

  /*--Project dropdown list--*/

  getProjectDropdownList(): Observable<HttpResponse<ProjectListDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("token", this.userSessionService.userToken);
    return this.http.post<HttpResponse<ProjectListDetail[]>>("projects/ProjectListFordropDown", formData);
  }

}
